import Typography from '@components/std-components/Typography'
import React, { FC, memo } from 'react'

const QtyCellLabelText: FC<{ translation: string }> = memo(props => {
  const { translation } = props
  return (
    <Typography variant='caption' color='qty-labels'>
      {translation}
    </Typography>
  )
})

export default QtyCellLabelText
